import { centerable as n } from "../decorators/centerable.js";
import { stylable as p } from "../decorators/stylable.js";
import { ALIGN_CLASSES_INVERSE as a } from "../../constants.js";
const f = p(
  n({
    inline: !1,
    content: "inline*",
    group: "block",
    attrs: {
      type: { default: "paragraph" }
    },
    parseDOM: [
      {
        tag: "p",
        getAttrs(t) {
          let e;
          return t.parentElement && t.parentElement.classList.forEach((r) => {
            a[r] && (e = a[r]);
          }), { alignment: e };
        }
      }
    ],
    toDOM() {
      return ["p", 0];
    }
  })
);
export {
  f as paragraphSpec
};
